module.exports = __webpack_public_path__ + "static/media/24UHCHR26.cdb2d69c.jpg";